import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { GenericChat } from '../GenericChat/GenericChat';
import { CHAT_ROLES, FILE_UPLOAD_EXPLAIN_CHAT_ROOM } from '../constants';
import { useChat } from '../useChat';
import { handleSendMessage } from './functions';

const INIT_MESSAGE = 'Welcome! Let\'s get you started on the path to finding the best treatment options. Ask me anything about uploading your files to Leal.health, and I\'ll be happy to help.';

export const UploadExplainChat = ({ isFullMode }) => {
  const [init, setInit] = useState(false);

  const {
    chat: { messageHistory: chatHistory } = {},
    addMessages,
    setMessages,
  } = useChat(FILE_UPLOAD_EXPLAIN_CHAT_ROOM);

  useEffect(() => {
    if (init) {
      return;
    }
    if (!chatHistory?.length) {
      setMessages([{
        role: CHAT_ROLES.TINA,
        content: INIT_MESSAGE,
      }]);
    }
    setInit(true);
  }, [setMessages, chatHistory?.length, init]);

  const handleSendMessageClick = (prompt) => handleSendMessage({ prompt, addMessages });

  return init ? (
    <GenericChat
      handleSendMessageClick={handleSendMessageClick}
      chatHistory={chatHistory}
      isFullMode={isFullMode}
    />
  ) : null;
};

UploadExplainChat.propTypes = {
  isFullMode: PropTypes.bool,
};
